module.exports = __webpack_public_path__ + "static/img/introduce_1.3e563ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_1.png
// module id = w2/u
// module chunks = 1